export default "__VITE_ASSET__qGB9fS2O__"